import * as React from "react";

const TableShowArrowIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#171718"
            d="m10 15.888 1.775-1.775L20 22.338l8.225-8.225L30 15.887l-10 10z"
        ></path>
    </svg>
);

export default TableShowArrowIconSVG;
